import * as React from 'react';
import ContentEditable from 'react-contenteditable';

import { BOLD_BEGINS, BOLD_ENDS, isEdited } from '../../helpers/editedWords';
import { WordObject } from '../../interfaces/proofreaderActivities';

type EditInputProps = WordObject & { onWordChange: Function, numberOfResets: number, underlineErrors: boolean, nextWordStartsWithPunctuation?: boolean }

export default class EditInput extends React.Component<EditInputProps, {}> {
  handleWordChange = (e: any) => {
    const { wordIndex, onWordChange } = this.props
    const stripHTML = e.target.value.replace(/<\/?[^>]+(>|$)/g, '').replace(/&nbsp;/g, ' ')
    onWordChange(stripHTML, wordIndex, this.editInput)
  }

  setEditInputRef = node => this.editInput = node

  render() {
    const { currentText, originalText, underlined, wordIndex, paragraphIndex, numberOfResets, underlineErrors, nextWordStartsWithPunctuation} = this.props
    const beforeElements = []
    const afterElements = []
    let className = 'edit-input'
    if (nextWordStartsWithPunctuation) {
      className += ' no-right-margin'
    }
    if (underlined && underlineErrors) {
      className += ' underlined'
      // disabling tabIndex rule because this is a non-standard use case - since screenreader users will likely be using tab keys to navigate the passage, it is important that this information is discoverable in that mode
      /* eslint-disable jsx-a11y/no-noninteractive-tabindex */
      beforeElements.push(<span className="sr-only" tabIndex={0}>(underlined text begins here)</span>)
      afterElements.push(<span className="sr-only" tabIndex={0}>(underlined text ends here)</span>)
      /* eslint-enable jsx-a11y/no-noninteractive-tabindex */
    }
    if (isEdited({ currentText, originalText, })) {
      className += ' bolded'
      // disabling tabIndex rule because this is a non-standard use case - since screenreader users will likely be using tab keys to navigate the passage, it is important that this information is discoverable in that mode
      /* eslint-disable jsx-a11y/no-noninteractive-tabindex */
      beforeElements.push(<span className="sr-only" tabIndex={0}>{BOLD_BEGINS}</span>)
      afterElements.push(<span className="sr-only" tabIndex={0}>{BOLD_ENDS}</span>)
      /* eslint-enable jsx-a11y/no-noninteractive-tabindex */
    }
    const key = `${paragraphIndex}-${wordIndex}-${numberOfResets}`
    return (
      <React.Fragment>
        {beforeElements}
        <ContentEditable
          className={className}
          data-gramm={false}
          html={currentText}
          innerRef={this.setEditInputRef}
          key={key}
          onChange={this.handleWordChange}
          spellCheck={false}
          tagName="span"
        />
        {afterElements}
      </React.Fragment>
    )
  }
}
